module.exports = __webpack_public_path__ + "img/icon_page6_phone.0e7186f8.png";